import { writable } from 'svelte/store';

function DB() {
	const { subscribe, update, get } = writable({
        player: {},
        players: [],
        shops: [],
        places: [],
        paths: [],
        blank: {
            shop: {},
            place: {},
            path: {},
        },
    });

	return {
		subscribe,
		update: (key, value) => update(x => {x[key] = value; return x}),
		set: (value) => update(x => {x = value; return x})
	};
}

export const db = DB();